import Vue from "vue";
import Router from "vue-router";
import store from "../../common/store";
import HomeTheme from "../../lobby/view/theme/HomeTheme.vue";
import ByFrameView from "../../backyard/Frame.vue";
import ByIndexView from "../../backyard/view/index/Index.vue";
import UserLoginView from "../../lobby/view/user/Login.vue";
import {byArticleRouter} from "./ArticleRouter";
import {byCarouselRouter} from "./CarouselRouter";
import {bySceneryRouter} from "./SceneryRouter";
import {byThemeRouter} from "./ThemeRouter";
import {byTopicRouter} from "./TopicRouter";
import {byBlogrollRouter} from "./BlogrollRouter";
import {byPersonRouter} from "./PersonRouter";
import {byVideoRouter} from "./VideoRouter";
import {byTankRouter} from "./TankRouter";
import {byUserRouter} from "./UserRouter";
import {byWheelRouter} from "./WheelRouter";

Vue.use(Router);

import $ from "jquery";

let router = new Router({
  mode: 'history',
  linkActiveClass: 'is-link-active',
  scrollBehavior: () => ({y: 0}),
  routes: [


    {
      path: '/cgd/by',
      name: "by",
      component: ByFrameView,
      meta: {requiresAuth: true},
      children: [
        {
          path: '',
          name: "byIndex1",
          component: ByIndexView,
          meta: {requiresAuth: true}
        },
        {
          path: 'index',
          name: "byIndex",
          component: ByIndexView,
          meta: {requiresAuth: true}
        },
        //登录页面
        {
          path: 'user/login',
          name: "default_user_login",
          component: UserLoginView,
          meta: {requiresAuth: false}
        },

        ...byArticleRouter,
        ...byCarouselRouter,
        ...bySceneryRouter,
        ...byThemeRouter,
        ...byTopicRouter,
        ...byBlogrollRouter,
        ...byPersonRouter,
        ...byVideoRouter,
        ...byTankRouter,
        ...byUserRouter,
        ...byWheelRouter
      ]
    },
    {
      path: '/intend-debug',
      name: "intend-debug",
      component: HomeTheme,
      meta: {requiresAuth: false},
      children: [
        {
          path: 'index',
          name: "intend-debug-index",
          component: ByIndexView,
          meta: {requiresAuth: false}
        }
      ]
    }
  ]
});


//add global interceptor.
router.beforeEach((to, from, next) => {

  //handle breadcrumbs things.
  if (to.meta.breadcrumbs) {
    store.state.breadcrumbs = to.meta.breadcrumbs;
  } else {
    store.state.breadcrumbs = [];
  }

  let title = "上海交通大学媒体与传播学院精品课程";
  if (to.meta.title) {
    title = to.meta.title;
  }

  if (document.title !== title) {
    document.title = title;
    $('meta[name=description]').remove();
    $('head').append('<meta name="description" content="' + title + '">');
  }

  //handle auth feature.
  if (to.meta.requiresAuth) {


    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.state.user.isLogin) {
      next()
    } else {
      next({
        path: '/cgd/by/user/login',
        query: {redirect: to.fullPath}
      })
    }
  } else {
    next()
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/common/router/index.js